import { render, staticRenderFns } from "./UserInvitationFlow.vue?vue&type=template&id=3e9697c0&"
import script from "./UserInvitationFlow.vue?vue&type=script&setup=true&lang=ts&"
export * from "./UserInvitationFlow.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports